import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ResetState } from 'src/app/actions/global.actions';
import { RouterService } from 'src/app/libs/data-access/services/router/router.service';

@Component({
  selector: 'tic-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  constructor(private router: Router, private routerService: RouterService,private globalStore: Store,) {

  }

  ngOnInit(): void {
    this.routerService.scrollToTop();
    setTimeout(() => {
      this.navigateToHomePage();
    }, 3000);
  }

  navigateToHomePage() {
    this.globalStore.dispatch(ResetState());
    this.router.navigate(['/home-page']);
  }
}